import { motion } from "framer-motion";
import { FadeUp, RevealLinesOnView } from "@/components/motion/Reveals";
import { useLang } from "@/i18n/LangContext";
import { useContent, resolveUrl } from "@/cms/ContentContext";
import { useLeafTx } from "@/cms/useTexts";
import { useSpacing } from "@/cms/useSpacing";

const Servicos = () => {
  const { t } = useLang();
  const { content } = useContent();
  const tx = useLeafTx();
  const { sectionPy, titleGap, overlineGap, divider } = useSpacing();
  const IMAGES = [
    resolveUrl(content?.images?.servico_01) || "",
    resolveUrl(content?.images?.servico_02) || "",
    resolveUrl(content?.images?.servico_03) || "",
  ];
  return (
    <section id="servicos" data-testid="servicos-section" className={`relative ${sectionPy("servicos")} ${divider()}`}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp>
          <div className={`overline overline-2x text-[#6B6554] ${overlineGap("servicos")}`}>{tx("servicos.overline", t.servicos.overline)}</div>
        </FadeUp>
        <div className="flex flex-col">
          {t.servicos.items.map((s, i) => (
            <motion.article
              key={s.num}
              data-testid={`servico-${s.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1] }}
              className="group relative grid grid-cols-12 gap-4 md:gap-8 items-start border-t border-[#3A3524]/15 py-14 md:py-20 hover:bg-[#EAE5D9]/40 transition-colors duration-700"
            >
              {/* Chapter number */}
              <div className="col-span-3 md:col-span-2">
                <div className="font-serif italic text-[#8C714D] text-6xl md:text-8xl leading-none">
                  {s.num}
                </div>
              </div>

              {/* Title + description */}
              <div className={`col-span-9 ${IMAGES[i] ? "md:col-span-6" : "md:col-span-10"}`}>
                <h3 className="font-serif text-3xl md:text-5xl text-[#3A3524] leading-[1.05] mb-6 tracking-tight">
                  {tx(`servicos.items.${i}.title`, s.title)}
                </h3>
                <p className="text-[#3A3524]/80 text-base md:text-lg leading-relaxed text-justify font-light max-w-lg">
                  {tx(`servicos.items.${i}.desc`, s.desc)}
                </p>
              </div>

              {/* Image (only if uploaded) */}
              {IMAGES[i] && (
                <div className="col-span-12 md:col-span-4 relative">
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.7, ease: [0.7, 0, 0.15, 1] }}
                    className="relative aspect-[4/5] overflow-hidden frame-clip border border-[#3A3524]/12"
                  >
                    <img
                      src={IMAGES[i]}
                      alt={s.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#3A3524]/20" />
                  </motion.div>
                </div>
              )}
            </motion.article>
          ))}
          <div className="border-t border-[#3A3524]/15" />
        </div>
      </div>
    </section>
  );
};

export default Servicos;
